import React from 'react';
import {Paper, Stack} from '@mui/material';
import IcrProducts from './IcrProducts';
import IcrExpertsList from './IcrExpertsList.jsx';
import IcrAssociationsPanel from './IcrAssociationsPanel';
import IcrCoveragePanel from './IcrCoveragePanel';
import GapMappingPanel from '../coverage/GapMappingPanel';

/** Temporary hide — keep GapMappingPanel wired for easy re-enable. */
const SHOW_GAP_MAPPING = false;

const IcrRightPanel = ({icr, role, onIcrUpdate, coverage = null}) => {
    return (
        <Stack spacing={2} flexShrink={0}>
            <IcrProducts icr={icr}/>
            <IcrCoveragePanel
                icrId={icr?.id}
                icrNumber={icr?.icrNumber}
                subject={icr?.subject || icr?.title}
                coverage={coverage}
                pir={icr}
            />
            {SHOW_GAP_MAPPING && (
                <Paper variant="outlined">
                    <GapMappingPanel/>
                </Paper>
            )}
            <IcrExpertsList icr={icr}/>
            <IcrAssociationsPanel
                icr={icr}
                role={role}
                onUpdate={associations => onIcrUpdate?.({associations})}
            />
        </Stack>
    );
};

export default IcrRightPanel;
